export default __webpack_public_path__ + "static/media/shopping-bag.ca303daf.svg";